__turbopack_context__.v({
  "container": "_6_FS7W_container",
  "rotate": "_6_FS7W_rotate",
  "variant--image": "_6_FS7W_variant--image",
  "variant--vector": "_6_FS7W_variant--vector",
});
